module.exports = __webpack_public_path__ + "c04d1551740d27ebcf504e8c7e12ed75.ttf";